import { Pipe, PipeTransform, InjectionToken, Inject, Optional, LOCALE_ID } from '@angular/core';
import { formatDate } from '@angular/common';
import { FitConfigProviderService } from '@shared/fit-config-provider.service';

export interface DateFormatSettings {
    dateTimeFormat: string;
    timeFormat: string;
    dateFormat: string;
}

export type DateMomentFormatType = 'dateTime' | 'date' | 'time' | 'dateTimeShort';

export const DATE_FORMAT_PIPE_FORMATS = new InjectionToken<DateFormatSettings>('dateFormatPipe.formatSettings');

@Pipe({
    name: 'dateFormat', pure: false,
    standalone: false
})
export class DateFormatPipe implements PipeTransform {
    constructor(
        @Optional() @Inject(DATE_FORMAT_PIPE_FORMATS) private _formatSettings: DateFormatSettings,
        @Inject(LOCALE_ID) private locale: string,
        private fitConfig: FitConfigProviderService
    ) { }

    public transform(date: Date | string | number, format?: DateMomentFormatType | string): string {
        if (!date) {
            return '';
        }

        if (date.toString().includes('[')) {
            return '';
        }

        let dateFormat = this._formatSettings.dateTimeFormat;

        if (format === 'userDate') {
            dateFormat = this.fitConfig.userDateFormat;
        } else if (format === 'userDateTime') {
            dateFormat = this.fitConfig.userDateFormat + ' ' + this._formatSettings.timeFormat;
        } else if (format === 'dateTime') {
            dateFormat = this._formatSettings.dateTimeFormat;
        } else if (format === 'date') {
            dateFormat = this._formatSettings.dateFormat;
        } else if (format === 'time') {
            dateFormat = this._formatSettings.timeFormat;
        } else if (format === 'dateTimeShort') {
            // Format: "MMM dd, y • h:mm a" (e.g., "Mar 19, 2025 • 12:33 PM")
            let dateToFormat = date;
            if (typeof dateToFormat === 'string') {
                dateToFormat = dateToFormat.replace(' ', 'T');
            }
            const datePart = formatDate(dateToFormat, 'MMM dd, y', this.locale);
            const timePart = formatDate(dateToFormat, 'h:mm a', this.locale);
            return `${datePart} • ${timePart}`;
        } else if (typeof format === 'string' && format.length > 0) {
            dateFormat = format;
        }

        if (typeof date === 'string') {
            date = date.replace(' ', 'T');
        }

        return formatDate(date, dateFormat, this.locale);
    }
}
